import { message } from "antd";
import axiosInstance from "../shared/axios";
const getSessions = async (params) => {
  try {
    let result = await axiosInstance.get("/sessions/viewAll", {
      params: {
        startDate: params?.startDate || "",
        endDate: params?.endDate || "",
        serviceID: params?.serviceID || "",
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading sessions");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading clients options",
    );
    return null;
  }
};
export const sessionsService = {
  getSessions,
};
